import React from "react";
import DynamicImage from "../common/DynamicImage";
import shape1 from "../../images/about/about-shape-07.png";
import shape2 from "../../images/about/about-shape-06.png";

const VisionMission = ({ data }) => {
    return (
        <div className="vision-mission-area ptb-100">
            <div className="container">
                <div className="row align-items-center gy-4">

                    {data?.statsItem?.map((item, index) => {
                        const isVision = item.layoutType === "vision";

                        return (
                            <div
                                key={item.id || index}
                                className="col-lg-6 col-md-12"
                                data-aos="fade-up"
                                data-aos-duration="1200"
                            >
                                <div
                                    className={
                                        isVision
                                            ? "our-vision-wrapper"
                                            : "our-mission-wrapper"
                                    }
                                >
                                    <div className={isVision ? "vision-shape" : "mission-shape"}>
                                        <img src={isVision ? shape1 : shape2} alt="shape" />
                                    </div>

                                    <div className={isVision ? "vision-thumb" : "mission-thumb"}>
                                        <DynamicImage image={item.image} />
                                    </div>

                                    <div
                                        className={
                                            isVision ? "vision-content" : "mission-content"
                                        }
                                    >
                                        <h3>{item.title}</h3>

                                        <p>
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                </div>
            </div>
        </div>
    );
};

export default VisionMission;
